import * as React from "react";
const SvgArrowDown = props => <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15 8L10 13L5 8" strokeWidth={1.25} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgArrowDown;